import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const StepText = styled.h3`
    color: ${COLORS.white};
    ${FONTS.H3};

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H4};
    }
`;

export const Step = styled.span`
    color: ${COLORS.yellow};
`;

export const SubText = styled.span`
    ${FONTS.S};
    color: ${COLORS.GRAY_S};

    @media (max-width: ${wideBreakpoints.sMobile}) {
        ${FONTS.XS};
    }
`;

export const TitleWrap = styled.header`
    display: flex;
    flex-direction: column;
    gap: 5px;
    white-space: nowrap;
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        white-space: normal;
        gap: 8px;
    }
`;
